import { vOnClickOutside } from "@vueuse/components";

import type { App, Plugin } from "vue";

const plugin: Plugin = {
  install: (app: App<Element>) => {
    app.directive("on-click-outside", vOnClickOutside);
  },
};

export default plugin;
